export default __webpack_public_path__ + "static/media/ShellyHappyNoBackground.578e698c.png";